import Flag from "@assets/icons/MyBalance/Flag.png"
import { Form } from "antd"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
// import { useNavigate } from "react-router-dom"
import { userApi } from "src/api/userApi"
import Button from "src/components/Button"
import CSInput from "src/components/Input/Index"
import CommonModal, { CommonModalProps } from "src/components/Modal"
import { useCountTime } from "src/customHook/useCountTime"
import { secondTo } from "src/util"

type DeleteAccountSnsProps = {
  handleClose: () => void
  handleOpenForgotPassword?: () => void
  handleOpenSuccess?: () => void
  timeOtp?: number
} & CommonModalProps

const DeleteAccountSns: React.FC<DeleteAccountSnsProps> = ({
  handleClose,
  handleOpenForgotPassword,
  timeOtp,
  handleOpenSuccess,
  isOpen,
  ...props
}) => {
  // const dispatch = useAppDispatch()
  const [form] = Form.useForm()
  const { t } = useTranslation()

  // const navigate = useNavigate()
  // const [searchParams] = useSearchParams()
  const { countTime, handleSetCountTime } = useCountTime(0)

  const onFinish = async (values: any) => {
    try {
      const resp: any = await userApi.deleteAccountSns({ otp: +values.otp })

      if (resp?.result) {
        handleOpenSuccess && handleOpenSuccess()
      } else if (resp.errorCode === "INVALID_OTP") {
        form.setFields([
          {
            name: "otp",
            errors: [
              t(
                "OTP is not correct. Please input the correct OTP you received.",
              ),
            ],
          },
        ])
      } else if (resp.errorCode === "EXPIRED_OTP") {
        form.setFields([
          {
            name: "otp",
            errors: [t("OTP has expired. Please request a new OTP.")],
          },
        ])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleResendOtp = async () => {
    try {
      const resp: any = await userApi.getOtpDeleteAcc()
      if (resp.result) {
        handleSetCountTime(60)
      }
    } catch (error) {
      console.error(error)
    }
  }

  // useEffect(() => {
  //   if (timeOtp) {
  //     handleSetCountTime(timeOtp)
  //   }
  // }, [timeOtp])

  useEffect(() => {
    if (isOpen === false) {
      form.resetFields()
    }
  }, [isOpen])

  useEffect(() => {
    const sentOtp = async () => {
      try {
        const resp: any = await userApi.getOtpDeleteAcc()
        if (resp.result) {
          handleSetCountTime(60)
        }
      } catch (error) {
        console.error(error)
      }
    }
    sentOtp()
  }, [])

  return (
    <CommonModal
      isOpen={isOpen}
      imageTop={
        <img className="object-cover ml-3" src={Flag} alt="brand-logo" />
      }
      handleClose={handleClose}
      {...props}
    >
      <p className="font-pretendard500 text-[20px]">{t("회원탈퇴")}</p>
      <p className="text-gray1 text-[14px] mt-[6px]">
        {t("delete account sns subtitle")}
      </p>
      <div className="mt-4">
        <Form
          layout="vertical"
          requiredMark={false}
          onFinish={onFinish}
          form={form}
        >
          <CSInput
            inputType="text"
            name="otp"
            placeholder={t("입력하세요.")}
            inputHeight={48}
            className="!mb-[10px]"
            borderColor="#D4D4D4"
            rules={[
              {
                required: true,
                message: t("Please enter OTP Code."),
              },
            ]}
            onChange={(e) => {
              const inputValue = e.target.value
              const numericValue = inputValue.replace(/\D/g, "")
              form.setFieldValue("otp", numericValue)
            }}
          />
          <div className="flex items-center gap-[10px] mb-[40px]">
            <button
              className="w-full border-[1px] border-primary h-[48px]"
              onClick={handleClose}
              type="button"
            >
              {t("Cancel")}
            </button>
            <button className="bg-primary w-full h-[48px] font-pretendard700 text-primaryWhite">
              {t("Delete account")}
            </button>
          </div>
          <p className="mt-[40px] text-center text-[14px] font-pretendard400 text-gray1">
            {t("Did not receive?")}{" "}
            {countTime > 0 ? (
              <>
                {t("Resend after")}{" "}
                <span className="text-[14px] font-pretendard700 text-primary">
                  {secondTo(countTime)}s
                </span>
              </>
            ) : (
              <span
                onClick={handleResendOtp}
                className="text-[14px] text-primaryBlue underline cursor-pointer"
              >
                {t("Resend OTP via mail")}
              </span>
            )}
          </p>
        </Form>
      </div>
    </CommonModal>
  )
}

export default DeleteAccountSns
